import axios, { AxiosResponse } from "axios";
import { IAppFeatureConfigs } from "../models/app_models";

const appURL = process.env.REACT_APP_ISTANBUL_URL + "/app"

export const getAppFeatureConfigs = (profile?: string | null): Promise<AxiosResponse<IAppFeatureConfigs>> => {
    axios.defaults.baseURL = appURL
    let url = `/feature-configs/${process.env.REACT_APP_APP_KEY}`
    if(profile)
        url += `?profile=${profile}`
    return axios.get(url)
}